/** =========================================================
 * Project part act remark templates controller
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.page-project-part-act-remark-templates')
    .controller('ProjectPartActRemarkTemplatesController', ProjectPartActRemarkTemplatesController);

  ProjectPartActRemarkTemplatesController.$inject = ['$rootScope', '$scope', '$state', '$stateParams'];

  function ProjectPartActRemarkTemplatesController($rootScope, $scope, $state, $stateParams) {
    var vm = this;

    vm.pageTitle = $state.current.title;
    vm.pageSubTitle = $state.current.subTitle;
    vm.init = false;

    if ($rootScope.appConfig) {
      activate();
    } else {
      var getAppConfig = $rootScope.$watch('appConfig', function (value) {
        if (value) {
          activate();
          getAppConfig();
        }
      });
    }

    // //////////////

    function activate() {
      vm.init = true;

      Raven.captureBreadcrumb({
        message: 'Page project part remark templates',
        data: {
          filters: $stateParams.filters
        }
      });

      vm.tableConfig = {
        model: 'project_part_act_remark_template',
        getDataParams: {
          order: {
            id: 'desc'
          },
          with: [
            'user',
            {
              project_part_act_remark_template_type: ['id', 'name', 'color']
            }
          ]
        },
        resources: [
          'project_part_act_remark_template_type'
        ],
        filters: angular.copy($stateParams.filters),
        fields: [{
          title: 'Value',
          key: 'name',
          order: true
        }, {
          title: 'Type',
          key: 'project_part_act_remark_template_type_id',
          order: true,
          customType: 'tags',
          value: function (item) {
            return item.project_part_act_remark_template_type_id !== null ? [item.project_part_act_remark_template_type] : [];
          }
        }, {
          title: 'Added by user',
          key: 'user_id',
          value: function (item) {
            return item.user.name;
          },
          order: true
        }, {
          title: 'Date added',
          key: 'created_at',
          customType: 'date',
          order: true
        }],
        add: {
          template: 'app/views/dialogs/item-project-part-act-remark-template.html'
        },
        edit: {
          template: 'app/views/dialogs/item-project-part-act-remark-template.html',
          except: ['project_parts', 'project_part_act_remark_template_type', 'user']
        },
        delete: {}
      };

      vm.tableConfig.getData = function () {
        try {
          return $rootScope.helpers.defaultGetData(vm.tableConfig);
        } catch (error) {
          Raven.captureException(error);
        }

        return $rootScope.helpers.emptyPromise();
      };

      vm.tableConfig.getData();

      $rootScope.helpers.initActiveTableConfig(vm.tableConfig);
    }
  }
})();
